import React, { Component } from "react";
import axios from "axios";
import config from "../config.json";

import QuestionHeader from "./header";
import Question from "./question";
import Form from "./form";
import Summary from "./summary";
import Footer from "./footer";
import RestartButton from "./restart";
import MyLoader from "./loader";

class Quiz extends Component {
  constructor() {
    super();
    this.state = {
      questions: [],      // contains question data
      index: 0,           // current Question Index
      chosenResults: [],  // holds the id to the results summary and prompts for that one
      selectedChoices: [],// the choices (prompts) chosen from the form
      question: [],       // the current questionn to render
      loading: true,      // loading conntent
      firstQuestion: false
    };
    this.ref = React.createRef();
  }

  // When new questions load, scroll to the top of the quiz content area.
  scrollToRef = ref => {
    //ref.current && window.scrollTo(0, ref.current.offsetHeight);
    //ref.current && window.scrollTo(0, 345);
    ref.current && window.scrollTo(0, 250);
    //ref.current.scrollIntoView();
    //window.scrollTo({ behavior: "smooth", top: ref.current.offsetTop });
  };

  // get the data after the component mounts

  async componentDidMount() {
    // pending > resolved (success) OR rejected (failure)
    const { data: questions } = await axios.get(config.apiEndPoint, {
      crossDomain: true
    }); // async operation - returns json data -> rename to questions
    this.setState({ questions, loading: false });

    this.setState({ index: this.getStartQuestion() });
    this.setState(
      { question: this.getQuestion(this.state.index) },
      this.updateIndex
    );
  }

  // The first question will have the boolean "start" set.
  getStartQuestion() {
    const first = this.state.questions.find(m => m.start === "1");
    this.setState({ firstQuestion: true });
    return first.nid;
  }

  // find the question based on it's id
  getQuestion(id) {
    //console.log("state in getquestion", this.state);
    return this.state.questions.find(m => m.nid === id);
  }
  getResultsIndex(thisArray, target) {
    return thisArray.find(m => m.result === target);
  }
  // after a new question is displayed, set the index of where to go next
  // if they have to answer a prompt first, set it to 0 and the prompt handler will update it.
  updateIndex() {
    this.setState(
      {
        index: this.state.question.next ? this.state.question.next : 0
      },
      () => {
       //console.log("update index", this.state.index);
      }
    );
  }

  handleNext = () => {
    //
    // on the last question, their only choice is to go back to the start.
    // So, that's what we'll do, plus clear out old choices they made
    //

    if (this.state.question.last === "1") {
      this.resetQuiz();
    } else {
      // load the next question based on the chosen option. index was set when the choice was made
      // use a callback because setstate is asynchronous so state will be changed in callback
      this.setState(
        { question: this.getQuestion(this.state.index), firstQuestion: false },
        this.updateIndex
      );
    }
    this.scrollToRef(this.ref);
  };

  handleRestart = () => {
    this.resetQuiz();
  };

  resetQuiz = () => {
    const qid = this.getStartQuestion();
    const nextQuestion = this.getQuestion(qid);
    this.setState(
      {
        index: qid,
        question: nextQuestion,
        selectedChoices: []
      },
      this.updateIndex
    );
  };

  //
  // when an item from the Form is toggled (chosen) we'll add it to an array
  // onSubmit, we'll iterate through that array and find the id to the results
  // for those choices made
  //
  handleSelect = e => {
    const newSelection = e.target.value;
    let newSelectionArray;

    // keep an array of the options they checked

    // they unchecked this choice
    if (this.state.selectedChoices.indexOf(newSelection) > -1) {
      newSelectionArray = this.state.selectedChoices.filter(
        s => s !== newSelection
      );
      // they checked this choice
    } else {
      newSelectionArray = [...this.state.selectedChoices, newSelection];
    }
    //this.setState({ selectedChoices: newSelectionArray });
    this.setState(state => {
      return { selectedChoices: newSelectionArray };
    });
  };

  //
  // Here's how this goes:
  // We have that array of prompts that were chosen.
  // We need to iterate through that, and set up an array of id's to
  // the contents to the results summary for that choice.
  //
  // Uses the same Choice options data structure, like this:
  // choice {prompt, target}, where
  //   prompt =  the label for the checkbox
  //   target =  the node id to the summary for that results
  // Note: The same results summary may be used by more than one toggle option.
  //

  handleSubmit = () => {
    let newResultsArray = [];
    // console.log("handle submit", this.state.selectedChoices);
    // set up the list of results

    for (var i = 0; i < this.state.question.choices.length; i++) {
      var choice = this.state.question.choices[i];

      // one of the selected choices?
      if (this.state.selectedChoices.indexOf(choice.choice_prompt) > -1) {
        // was this same summary already used?

        // There might be more than 1 target (results paragraph) for a given selection.

          for (var n=0; n < choice.choice_target.length; n++) {
            var rIndex = this.getResultsIndex(
              newResultsArray,
              choice.choice_target[n]
            );

            if (!rIndex) {
              var newObject = {
                result: choice.choice_target[n],
                prompts: [choice.choice_prompt]
              };
              newResultsArray.push(newObject);
            } else {
              rIndex.prompts.push(choice.choice_prompt);
            }
          }


      }
    }
    this.setState({ chosenResults: newResultsArray });
    this.handleNext();
  };
  //
  // To handle the prompts in the footer area - they determine what question to show next.
  // each choice will have a target that is the id of the question to show next is this choice was made.
  handleChoice = target => {
    this.setState({ index: target });
  };

  resetChosenResults = () => {
    this.setState({
      selectedChoices: []
    }); /* clear out selection for the next form*/
  };

  render() {
    if (this.state.loading) return <MyLoader />;

    const type = this.state.question ? this.state.question.type : "";
    //console.log(this.state.question,"question");
    return (
      <div className="row column">
        <div className="region-content driver-tool">
          <header className="dsa-header" ref={this.ref}>
            <h1>
              American Geriatrics Society (AGS) Older Driver Safety
              Questionnaire
            </h1>
          </header>
          <div className="driver-content">
            <QuestionHeader track={this.state.question.track} />
            {type === "full" && <Question item={this.state.question} />}
            {type === "summary" && (
              <Summary chosenResults={this.state.chosenResults} />
            )}
            {type === "form" && (
              <Form
                item={this.state.question}
                onSelect={this.handleSelect}
                selectedChoices={this.state.selectedChoices}
              />
            )}
          </div>
        </div>
        <Footer
          item={this.state.question}
          onChoice={this.handleChoice}
          onNext={type === "form" ? this.handleSubmit : this.handleNext}
          nextIndex={this.state.index}
        />
        {!this.state.firstQuestion && this.state.question.last !== "1" && (
          <RestartButton onRestart={this.handleRestart} />
        )}
      </div>
    );
  }
}

export default Quiz;
